function cdbBuild(config, choice, group) {
  const take = (list, id) => { const item = list.find(x => x.id === id); if (!item) throw new Error('Ugyldig valg'); return item; };
  const fabric = key => { const item = config.fabrics.find(x => x.key === key); if (!item) throw new Error('Velg tekstil'); return item; };
  const dualFirmness=config.firmness_mode==='dual'||(config.firmness_mode!=='single'&&Number(config.component_quantity||1)>1);
  const isSingle=!dualFirmness;
  const ranks = isSingle
    ? [config.firmness.indexOf(choice.left)]
    : [config.firmness.indexOf(choice.left), config.firmness.indexOf(choice.right)];
  if (ranks.some(x => x < 0)) throw new Error(isSingle?'Velg fasthet':'Velg fasthet på begge sider');
  ranks.sort((a,b) => a-b);
  const name = isSingle ? config.firmness[ranks[0]] : (ranks[0] === ranks[1] ? config.firmness[ranks[0]] : ranks.map(x => config.firmness[x]).join('/'));
  const bed = config.bed.find(x => x.name === name);
  if (!bed) throw new Error('Fasthetskombinasjonen mangler');
  const lines = [];
  if (!group) throw new Error('Konfigurasjonen mangler referanse');
  const modelLabel=config.model_label||'Malö';
  const productHeading=config.product_heading||(modelLabel==='Kornö'?'Kornö kontinentalseng':'Malö rammemadrass');
  const displaySize=config.display_size||`${config.width} × ${config.length}`;
  const compactSize=`${config.width}x${config.length}`;
  const componentSize=config.component_quantity>1?`${config.component_quantity} × ${config.component_width}x${config.length}`:compactSize;
  const enabledLegLayouts=(config.leg_layouts||[]).filter(x=>x.enabled);
  const legLayout=enabledLegLayouts.find(x=>x.key===choice.legLayout)||enabledLegLayouts[0]||null;
  let legQuantity=Number(config.leg_quantity||1);
  let legCount=Number(config.leg_count||legQuantity*4);
  let supportLeg=null;
  let legText=`${legQuantity} ${legQuantity===1?'pakke':'pakker'} / ${legCount} ben`;
  if(legLayout){
    legQuantity=Number(legLayout.visible_leg_packages||legQuantity);
    legCount=Number(legLayout.visible_leg_count||legQuantity*4);
    if(legLayout.key==='4-plus-support'){
      const selectedLegName=choice.leg?take(config.legs,choice.leg).name:'';
      const heightMatch=selectedLegName.match(/\b(13|17|23|30) cm$/i);
      const height=heightMatch?heightMatch[1]:'';
      if(!['13','17','23'].includes(height))throw new Error('Støtteben kan brukes med 13, 17 eller 23 cm ben.');
      const range=height==='13'?'9–15 cm':'17–23 cm';
      supportLeg=(config.support_legs||[]).find(x=>x.range===range);
      if(!supportLeg)throw new Error('Støtteben mangler for valgt høyde.');
      legText='1 pakke / 4 synlige ben + 1 pakke / 2 støtteben';
    }else{
      legText=`${legQuantity} ${legQuantity===1?'pakke':'pakker'} / ${legCount} synlige ben`;
    }
  }
  const bedFeeRule=config.exclusive_bed_fee||'box_spring_double';
  const headboardFeeRule=config.exclusive_headboard_fee||'headboard_double';
  const add = (item, role, properties = {}, quantity = 1) => lines.push({id:item.id,quantity,properties:{_cdb_configuration:group,_cdb_role:role,_cdb_version:'2',_cdb_product_heading:productHeading,Konfigurasjon:modelLabel+' '+displaySize,Komponent:item.name,...properties},name:item.name,unitPrice:item.price,compareAtPrice:item.compareAtPrice||0});
  const fee = (rule, text, target) => add({...config.fees[rule],name:'Exclusive tekstil · '+target},rule,{'Tekstil':text,'Gjelder':target});
  const bedFabric = fabric(choice.bedFabric);
  const bedProps=isSingle
    ? {'Fasthet':choice.left,'Tekstil':bedFabric.name,'Størrelse':compactSize+' cm','_cdb_source_sku':bed.source_sku||bed.sku,'Overmadrass':choice.topper ? take(config.topper,choice.topper).name : 'Uten overmadrass','Ben':choice.leg ? take(config.legs,choice.leg).name+' · '+legText : 'Uten ben','Gavl':choice.headboard ? take(config.headboards,choice.headboard).name : 'Uten gavl'}
    : {'Venstre fasthet':choice.left,'Høyre fasthet':choice.right,'Tekstil':bedFabric.name,'Størrelse':compactSize+' cm','_cdb_source_sku':bed.source_sku||bed.sku,'Overmadrass':choice.topper ? take(config.topper,choice.topper).name : 'Uten overmadrass','Ben':choice.leg ? take(config.legs,choice.leg).name+' · '+legText : 'Uten ben','Gavl':choice.headboard ? take(config.headboards,choice.headboard).name : 'Uten gavl'};
  if(!isSingle){
    if(config.base_structure_label)bedProps['Basestruktur']=config.base_structure_label;
    else if(Number(config.component_quantity||1)>1)bedProps['Størrelse']=compactSize+' cm ('+componentSize+')';
  }
  add({...bed,name:modelLabel+' '+compactSize+' · '+bed.name},'bed',bedProps);
  if (bedFabric.collection === 'Exclusive') fee(bedFeeRule,bedFabric.name,'Seng');
  if (choice.topper) {
    const topper = take(config.topper,choice.topper);
    const props = {};
    if (topper.name.startsWith('Luxury')) {
      props.Tekstil = bedFabric.name;
      add(topper,'topper',props);
      if (bedFabric.collection === 'Exclusive') fee('luxury_topper',bedFabric.name,'Luxury overmadrass');
    } else add(topper,'topper');
  }
  if (choice.leg) {
    const selectedLeg = take(config.legs,choice.leg);
    if (choice.legHeightConfirmed !== 'yes') throw new Error('Velg høyde på bena');
    if (!/\b(13|17|23|30) cm$/i.test(selectedLeg.name)) throw new Error('Velg høyde på bena');
    add(selectedLeg,'legs',{'Antall ben':legText},legQuantity);
    if(supportLeg){
      add(supportLeg,'support_legs',{'Plassering':'Skjult i midten under sengen','Antall støtteben':'1 pakke / 2 stk.'},1);
    }
  }
  if (choice.headboard) {
    const headboard = take(config.headboards,choice.headboard);
    const headboardNeedsFabric = !/^(Pinnö|Otterö)(?!.*Sälö)/i.test(headboard.name);
    if (headboardNeedsFabric) {
      add(headboard,'headboard',{'Tekstil':bedFabric.name});
      if (bedFabric.collection === 'Exclusive') fee(headboardFeeRule,bedFabric.name,'Gavl');
    } else {
      add(headboard,'headboard');
    }
  }
  const manifest=lines.map(line=>line.properties._cdb_role+':'+line.id+':'+line.quantity).sort().join('|');
  for(const line of lines){
    if(!/^\d+$/.test(String(line.id))||!Number.isSafeInteger(line.unitPrice)||line.unitPrice<0) throw new Error('Pris eller variant mangler');
    line.properties._cdb_manifest=manifest;
  }
  return {lines,total:lines.reduce((sum,x)=>sum+x.unitPrice*x.quantity,0),cart:{items:lines.map(({id,quantity,properties})=>({id,quantity,properties}))}};
}
if (typeof module !== 'undefined') module.exports = {cdbBuild};

(async () => {
  const root = document.querySelector('[data-cdb-pilot]');
  if (!root) return;
  const config = JSON.parse(root.querySelector('[data-config]').textContent);

  const route=path=>(window.Shopify?.routes?.root||'/')+path;
  const allItems=[...config.bed,...config.topper,...config.legs,...config.headboards,...Object.values(config.fees)];
  const catalog=JSON.parse(root.querySelector('[data-cdb-catalog]').textContent);
  for(const item of allItems){
    const live=catalog.find(variant=>String(variant.id)===String(item.id));
    if(!live){root.querySelector('[data-status]').textContent='Konfigurasjonen er ikke tilgjengelig. Kontakt oss for hjelp.';return;}
    item.price=live.price;item.compareAtPrice=live.compareAtPrice||0;item.available=live.available;
  }
  const lowestBed=config.bed.reduce((min,item)=>item.price<min.price?item:min,config.bed[0]);
  root.querySelector('.cdb-v2__from strong').textContent=new Intl.NumberFormat('nb-NO',{style:'currency',currency:'NOK',maximumFractionDigits:0}).format(lowestBed.price/100);
  const fromCompare=root.querySelector('.cdb-v2__from-compare');
  const fromBadge=root.querySelector('.cdb-v2__from-discount');
  const fromSale=lowestBed.compareAtPrice>lowestBed.price;
  if(fromCompare){fromCompare.hidden=!fromSale;fromCompare.textContent=fromSale?new Intl.NumberFormat('nb-NO',{style:'currency',currency:'NOK',maximumFractionDigits:0}).format(lowestBed.compareAtPrice/100):'';}
  if(fromBadge){fromBadge.hidden=!fromSale;fromBadge.textContent=fromSale?'−'+Math.round((lowestBed.compareAtPrice-lowestBed.price)*100/lowestBed.compareAtPrice)+' % rabatt':'';}
  const master = root.querySelector('[data-fabrics]');
  if (master) { const fabrics=JSON.parse(master.textContent); if(fabrics.length) config.fabrics=fabrics; }
  const form = root.querySelector('form');
  const heroImage=root.querySelector('.cdb-v2__hero img');
  const originalHero=heroImage?{src:heroImage.getAttribute('src')||'',srcset:heroImage.getAttribute('srcset')||'',sizes:heroImage.getAttribute('sizes')||'',alt:heroImage.getAttribute('alt')||''}:null;
  const restoreHero=()=>{
    if(!heroImage||!originalHero)return;
    heroImage.src=originalHero.src;
    if(originalHero.srcset)heroImage.setAttribute('srcset',originalHero.srcset);else heroImage.removeAttribute('srcset');
    if(originalHero.sizes)heroImage.setAttribute('sizes',originalHero.sizes);else heroImage.removeAttribute('sizes');
    heroImage.alt=originalHero.alt;
  };
  if(heroImage){heroImage.addEventListener('error',()=>{if(originalHero&&heroImage.getAttribute('src')!==originalHero.src)restoreHero();});}
  const cylindoBase=config.cylindo_base||'https://content.cylindo.com/api/v2/6137/products/MALO_180X200/frames/3/MALO_180X200.webp';
  const cylindoEnabled=true;
  const cdbFabricCodeMap=new Map([
    ['cliff light grey','0CLLG'],
    ['luxury black','0LBL'],
    ['luxury dark grey','0LDG'],
    ['luxury light grey','0LLG'],
    ['luxury sand','0LSA'],
    ['wool beige','0WBE'],
    ['wool black','0WBL'],
    ['wool dark grey','0WDG'],
    ['wool light grey','0WLG'],
    ['designers guild zaragoza eggshell','0DEG'],
    ['designers guild zaragoza pebble','0DPE'],
    ['designers guild zaragoza steel','0DST'],
    ['designers guild rothesay graphite','0DRGR'],
    ['designers guild rothesay pumice','0DRPU'],
    ['designers guild rothesay zinc','0DRZI'],
    ['designers guild rothesay stone','0DRST']
  ]);
  const cylindoFabricMap=new Map([
    ['0CLLG','CLIFF_LIGHT_GREY'],
    ['0LBL','LUXURY_BLACK'],
    ['0LDG','LUXURY_DARK_GREY'],
    ['0LLG','LUXURY_LIGHT_GREY'],
    ['0LSA','LUXURY_SAND'],
    ['0WBE','BEIGE_WOOL'],
    ['0WBL','BLACK_WOOL'],
    ['0WDG','DARK_GREY_WOOL'],
    ['0WLG','LIGHT_GREY_WOOL'],
    ['0DEG','DG_ZARAGOZA_EGGSHELL'],
    ['0DPE','DG_ZARAGOZA_PEBBLE'],
    ['0DST','DG_ZARAGOZA_STEEL'],
    ['0DRGR','DG_ROTHESAY_GRAPHITE'],
    ['0DRPU','DG_ROTHESAY_PUMICE'],
    ['0DRZI','DG_ROTHESAY_ZINK'],
    ['0DRST','DG_ROTHESAY_STONE'],
    ['0E16','RO_ASURI_CASHEW'],
    ['0E31','KV_MELANGE_NAP211'],
    ['0E00','DG_GLENVILLE_ZINC'],
    ['0E01','DG_GLENVILLE_GRANITE'],
    ['0E02','DG_GLENVILLE_CELADON'],
    ['0E03','DG_GLENVILLE_OYSTER'],
    ['0E18','RO_ASURI_MULBERRY'],
    ['0E19','RO_ASURI_ROSE'],
    ['0E20','RO_ASURI_ANTLER'],
    ['0E21','RO_ASURI_PIGEON'],
    ['0E22','DG_AZUARA_ECRU'],
    ['0E23','DG_AZUARA_NATURAL'],
    ['0E24','RO_LOOP_OYSTER'],
    ['0E25','RO_LOOP_STONE'],
    ['0E26','RO_LOOP_EVERGREEN'],
    ['0E27','RO_LOOP_MARINE'],
    ['0E28','DG_NOTTHING_HILL_SLATE'],
    ['0E29','DG_DERWEN_JAPANESE_INK'],
    ['0E30','DG_DERWEN_RETRO_OLIVE'],
    ['0E32','KV_MELANGE_NAP111'],
    ['0E33','KV_MELANGE_NAP191'],
    ['0E34','KV_FIORD2_322'],
    ['0E35','KV_FIORD2_262'],
    ['0E37','DG_SKYE_CHALK'],
    ['0E38','DG_SKYE_ZINC'],
    ['0E39','DG_SKYE_AQUA'],
    ['0E40','DG_SKYE_MIDNIGHT']
  ]);
  const normalizeCylindoKey=value=>String(value||'').trim().toLowerCase().replace(/\s+e\d+$/i,'').replace(/\s+/g,' ');
  const cylindoToken=value=>String(value||'')
    .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
    .replace(/æ/gi,'AE').replace(/ø/gi,'O').replace(/å/gi,'A')
    .replace(/[^a-z0-9]+/gi,'_').replace(/^_+|_+$/g,'').toUpperCase();
  const cylindoFabricCandidates=fabric=>{
    if(!fabric)return [];
    const normalized=normalizeCylindoKey(fabric.name);
    const exclusive=fabric.name.match(/\bE(\d{2})\b/i);
    const cdbCode=exclusive?'0E'+exclusive[1]:cdbFabricCodeMap.get(normalized);
    const known=cdbCode?cylindoFabricMap.get(cdbCode):'';
    const withoutCode=fabric.name.replace(/\s+E\d+$/i,'').trim();
    const withoutBrand=withoutCode.replace(/^Designers Guild\s+/i,'').replace(/^Romo Group\s+/i,'').replace(/^Kvadrat\s+/i,'');
    let supplierCandidate='';
    if(/^Designers Guild\s+/i.test(withoutCode))supplierCandidate='DG_'+cylindoToken(withoutBrand);
    else if(/^Romo Group\s+/i.test(withoutCode))supplierCandidate='RO_'+cylindoToken(withoutBrand);
    else if(/^Kvadrat\s+/i.test(withoutCode)){
      const melange=withoutBrand.match(/^Melange\s+NAP\s+(\d+)/i);
      const fiord=withoutBrand.match(/^Fiord2\s+(\d+)/i);
      supplierCandidate=melange?'KV_MELANGE_NAP'+melange[1]:(fiord?'KV_FIORD2_'+fiord[1]:'KV_'+cylindoToken(withoutBrand));
    }
    const candidates=[known,supplierCandidate,cdbCode,cdbCode?.replace(/^0/,''),cylindoToken(withoutBrand),cylindoToken(withoutCode)].filter(Boolean);
    return [...new Set(candidates)];
  };
  const cylindoLegValue=leg=>{
    if(!leg)return '';
    const name=leg.name||'';
    const selectedHeight=name.match(/\b(13|17|23|30) cm$/i)?.[1];
    if(!selectedHeight)return '';
    const height=selectedHeight==='17'?'13':selectedHeight==='30'?'23':selectedHeight;
    if(/^Cylinder Eik/i.test(name))return 'CYLINDER-BED-LEG-OAK-'+height;
    if(/^Cylinder Wenge/i.test(name))return 'CYLINDER-BED-LEG-WENGE-'+height;
    if(/^Cylinder Valnøtt/i.test(name))return 'CYLINDER-BED-LEG-WALNUT-'+height;
    if(/^Cylinder tre\/metall Hvit/i.test(name))return 'CYLINDER-ALYMINIUM-BED-LEGS-WHITE-ALU-'+height;
    if(/^Cylinder tre\/metall Oljet/i.test(name))return 'CYLINDER-ALYMINIUM-BED-LEGS-OAK-ALU-'+height;
    if(/^Cylinder tre\/metall Wenge/i.test(name))return 'CYLINDER-ALYMINIUM-BED-LEGS-WENGE-ALU-'+height;
    if(/^Cylinder tre\/metall Svart/i.test(name))return 'CYLINDER-ALYMINIUM-BED-LEGS-BLACK-ALU-'+height;
    if(/^Cylinder tre\/metall Antrasittgrå/i.test(name))return 'CYLINDER-ALYMINIUM-BED-LEGS-GREY-ALU-'+height;
    if(/^Classic Aluminium/i.test(name))return 'CLASSIC-BED-LEGS-ALUMINIUM-'+height;
    if(/^Classic Svart/i.test(name))return 'CLASSIC-BED-LEGS-BLACK-'+height;
    if(/^Segel Aluminium/i.test(name))return 'SEGEL-BED-LEGS-ALUMINIUM-'+height;
    if(/^Lod Svart/i.test(name))return 'LOD-BED-LEGS-BLACK-'+height;
    if(/^Lod Krom/i.test(name))return 'LOD-BED-LEGS-CHROME-'+height;
    if(/^Lod Messing/i.test(name))return 'LOD-BED-LEGS-BRASS-'+height;
    return '';
  };
  const cylindoHeadboardValue=headboard=>{
    if(!headboard)return '';
    const model=headboardModel(headboard.name);
    if(/^(Ängö|Angö)$/i.test(model))return 'ANGÖ';
    if(/^Bornö$/i.test(model))return 'BORNO';
    if(/^Rivö$/i.test(model))return 'RIVO';
    if(/^Rixö$/i.test(model))return 'RIXO';
    if(/^Solö$/i.test(model)){
      if(/\/\s*107\s*cm/i.test(headboard.name))return 'SOLO 107';
      if(/\/\s*120\s*cm/i.test(headboard.name))return 'SOLO 120';
    }
    return '';
  };
  const cylindoTopperValue=topper=>{
    if(!topper)return '';
    if(/^Luxury/i.test(topper.name))return 'LUXURY';
    if(/^Premium/i.test(topper.name))return 'PREMIUM';
    if(/^Prestige/i.test(topper.name))return 'PRESTIGE';
    return '';
  };
  let cylindoRequestToken=0;
  const updateCylindoHero=choice=>{
    if(!heroImage||!cylindoEnabled){restoreHero();return;}
    const fabric=config.fabrics.find(x=>x.key===choice.bedFabric);
    const leg=config.legs.find(x=>x.id===choice.leg);
    const topper=config.topper.find(x=>x.id===choice.topper);
    const headboard=config.headboards.find(x=>x.id===choice.headboard);
    const fabrics=cylindoFabricCandidates(fabric);
    const legs=cylindoLegValue(leg);
    const top=cylindoTopperValue(topper);
    const head=cylindoHeadboardValue(headboard);
    if(!fabrics.length||!legs||(topper&&!top)||(headboard&&!head)){restoreHero();return;}
    const token=++cylindoRequestToken;
    const buildUrl=upholstery=>{
      const params=new URLSearchParams();
      params.set('removeEnvironmentShadow','false');
      params.set('size','1024');
      params.append('feature','UPHOLSTERY:'+upholstery);
      params.append('feature','TOP MATTRESS:'+(top||'OFF'));
      params.append('feature','HEADBOARD TYPE:'+(head||'OFF'));
      params.append('feature','LEGS:'+legs);
      params.append('feature','BEDSIDE TABLE:OFF');
      return cylindoBase+'?'+params.toString().replace(/%3A/g,':').replace(/%2C/g,',');
    };
    const tryCandidate=index=>{
      if(token!==cylindoRequestToken)return;
      if(index>=fabrics.length){restoreHero();return;}
      const url=buildUrl(fabrics[index]);
      const preload=new Image();
      preload.onload=()=>{
        if(token!==cylindoRequestToken)return;
        heroImage.removeAttribute('srcset');
        heroImage.removeAttribute('sizes');
        heroImage.src=url;
        heroImage.alt=(config.model_label||'Malö')+' '+(config.display_size||config.width+' × '+config.length)+' konfigurert med '+fabric.name+(headboard?' og '+headboardModel(headboard.name):'');
        root.querySelectorAll('.cdb-v2__thumb').forEach(button=>button.classList.remove('is-active'));
      };
      preload.onerror=()=>tryCandidate(index+1);
      preload.src=url;
    };
    tryCandidate(0);
  };
  const zoomDialog=root.querySelector('[data-zoom-dialog]');
  const zoomClose=root.querySelector('[data-zoom-close]');
  const zoomImage=root.querySelector('[data-zoom-image]');
  const zoomTitle=root.querySelector('[data-zoom-title]');
const zoomDescription = root.querySelector('[data-zoom-description]');

const topperDescriptions = {"Prestige":"Overmadrass med Talalay-lateks og fiberfylt quilting. Avtakbart, vaskbart stretchtrekk.","Premium":"Overmadrass med kjerne av Talalay-lateks og fiberfylt quilting. Avtakbart, vaskbart stretchtrekk.","Luxury":"Vendbar overmadrass med kjerne av Talalay-lateks, bomull på sommersiden og ull på vintersiden."};

const openZoom=(url,title,kind)=>{
  if(!url)return;

  zoomImage.src=url;
  zoomImage.alt=title;
  zoomTitle.textContent=title;
  zoomDialog.dataset.kind=kind||'';

  if(zoomDescription){
    const topperName=Object.keys(topperDescriptions)
      .find(name=>title.toLowerCase().startsWith(name.toLowerCase()));

    const description=kind==='topper' && topperName
      ? topperDescriptions[topperName]
      : '';

    zoomDescription.textContent=description;
    zoomDescription.hidden=!description;
  }

  zoomDialog.showModal();
};

  zoomClose.addEventListener('click',()=>zoomDialog.close());
  zoomDialog.addEventListener('click',event=>{if(event.target===zoomDialog)zoomDialog.close();});
  const money = n => new Intl.NumberFormat('nb-NO',{style:'currency',currency:'NOK',maximumFractionDigits:0}).format(n/100);
  const singleBed=!(config.firmness_mode==='dual'||(config.firmness_mode!=='single'&&Number(config.component_quantity||1)>1));
  for (const key of (singleBed?['left']:['left','right'])) {
    const input=form.elements[key];
    const group=root.querySelector('[data-firmness="'+key+'"]');
    config.firmness.forEach(value=>{
      const button=document.createElement('button');
      button.type='button';
      button.className='cdb-v2__firmness-btn';
      button.dataset.value=value;
      button.textContent=value;
      button.setAttribute('aria-pressed','false');
      button.addEventListener('click',()=>{
        input.value=value;
        renderFirmness(key);
        update();
      });
      group.append(button);
    });
  }
  function renderFirmness(key){
    const input=form.elements[key];
    root.querySelectorAll('[data-firmness="'+key+'"] .cdb-v2__firmness-btn').forEach(button=>{
      const active=button.dataset.value===input.value;
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-pressed',String(active));
    });
  }
  const headboardInput=form.elements.headboard;
  const headboardQuick=root.querySelector('[data-headboard-quick]');
  const headboardMore=root.querySelector('[data-headboard-more]');
  const headboardDialog=root.querySelector('[data-headboard-dialog]');
  const headboardClose=root.querySelector('[data-headboard-close]');
  const headboardModalGrid=root.querySelector('[data-headboard-modal-grid]');
  const headboardModalOptions=root.querySelector('[data-headboard-modal-options]');
  const headboardConfirm=root.querySelector('[data-headboard-confirm]');
  const headboardZoom=root.querySelector('[data-headboard-zoom]');
  const headboardSelected=root.querySelector('[data-headboard-selected]');
  const pendingHeadboardName=root.querySelector('[data-headboard-pending-name]');
  const pendingHeadboardPrice=root.querySelector('[data-headboard-pending-price]');
  const headboardModels=['Rixö','Pinnö med Sälö','Otterö med Sälö','Lille Bornö','Low Tornö','Skärgård','Solö','Ängö','Angö','Bornö','Rivö','Pinnö','Otterö','Tornö'];
  const headboardModel=name=>headboardModels.find(model=>name.includes(model))||name.replace(/\b\d+\s*(?:x|×|cm).*$/i,'').replace(/[·\-]\s*$/,'').trim();
  const headboardNeedsFabric=name=>!/^(Pinnö|Otterö)(?!.*Sälö)/i.test(name);
  const headboardGroups=new Map();
  config.headboards.forEach(headboard=>{
    const model=headboardModel(headboard.name);
    if(!headboardGroups.has(model))headboardGroups.set(model,[]);
    headboardGroups.get(model).push(headboard);
  });
  const headboardImages=[
    ['Rixö','https://cdn.shopify.com/s/files/1/0911/4668/2732/files/5055_Rixo_9a73f4c9-ea28-4e25-b5d2-66aa4e19b1ca.jpg?v=1758108239'],
    ['Pinnö med Sälö','https://cdn.shopify.com/s/files/1/0911/4668/2732/files/5055_CarpeDiemBeds_Headboards_Pinno_Salo_282cm_80a431ca-a19e-4eb8-9fb5-32359efab6aa.jpg?v=1758108238'],
    ['Otterö med Sälö','https://cdn.shopify.com/s/files/1/0911/4668/2732/files/5055_CarpeDiemBeds_Headboards_Ottero_Salo_282cm_1_webp_45013ddb-7a72-4c6b-810b-40a30098aca0.jpg?v=1758108239'],
    ['Lille Bornö','https://cdn.shopify.com/s/files/1/0911/4668/2732/files/Sengegavl-Lilla-Borno-90X200-tekstil-Asuri-Mulberry-skra-VENSTRE_241d27c0-5e76-48d7-95fd-740e64167300.webp?v=1757667536'],
    ['Low Tornö','https://cdn.shopify.com/s/files/1/0911/4668/2732/files/Sengegavl-Low-Torno-tekstil-LUXURY-LIGHT-GREY-skra_280fa8c8-80f5-4bbe-b21a-80436328190d.webp?v=1757667537'],
    ['Skärgård','https://cdn.shopify.com/s/files/1/0911/4668/2732/files/Sengegavl-SKARGAARD-135X270-3X3-tekstil-LUXURY-LIGHT-GREY_4c23efcb-210d-41e5-a280-4c2f5c8f8b4b.webp?v=1757667538'],
    ['Solö','https://cdn.shopify.com/s/files/1/0911/4668/2732/files/Sengegavl-SOLO-107X180-tekstil-LUXURY-LIGHT-GREY_a854cbdb-beab-409e-9b88-8de7083750ee.webp?v=1758284880'],
    ['Ängö','https://cdn.shopify.com/s/files/1/0911/4668/2732/files/Sengegavl-Ango-120X180-tekstil-LUXURY-LIGHT-GREY-skra_5cecf03f-82ab-41eb-9e6b-a70479646047.webp?v=1757667532'],
    ['Angö','https://cdn.shopify.com/s/files/1/0911/4668/2732/files/Sengegavl-Ango-120X180-tekstil-LUXURY-LIGHT-GREY-skra_5cecf03f-82ab-41eb-9e6b-a70479646047.webp?v=1757667532'],
    ['Bornö','https://cdn.shopify.com/s/files/1/0911/4668/2732/files/Sengegavl-Borno-120X180-tekstil-LUXURY-LIGHT-GREY-skra_a3217a34-d5c0-42da-a464-b7bef626fc64.webp?v=1757667533'],
    ['Rivö','https://cdn.shopify.com/s/files/1/0911/4668/2732/files/5055_Rivo_e1496850-59d9-4987-9c11-31e30c5b8941.jpg?v=1758108239'],
    ['Pinnö','https://cdn.shopify.com/s/files/1/0911/4668/2732/files/5055_CarpeDiemBeds_Headboards_Pinno_SideTables_282cm_e95dc3e6-8bff-4451-976e-4d82aad53aab.jpg?v=1758108240'],
    ['Otterö','https://cdn.shopify.com/s/files/1/0911/4668/2732/files/5055_CarpeDiemBeds_Headboards_Ottero_282cm_1_webp_9be80e69-5831-463a-870c-49adbf3fbe55.jpg?v=1758108239'],
    ['Tornö','https://cdn.shopify.com/s/files/1/0911/4668/2732/files/Sengegavl-TORNO-tekstil-LUXURY-LIGHT-GREY_3d3f82cd-600a-43dd-8151-fcdc38d74095.webp?v=1757667538']
  ];
  const headboardImage=model=>headboardImages.find(([name])=>name===model)?.[1]||headboardImages.find(([name])=>model.includes(name))?.[1]||'';
  const headboardVariantLabel=(headboard,model)=>{
    const label=headboard.name.replace(model,'').replace(/^[\s·\-–—]+/,'').trim();
    return label||'Standard';
  };
  const makeHeadboardCard=(model,items,none=false)=>{
    const button=document.createElement('button');
    button.type='button';
    button.className='cdb-v2__headboard-type';
    button.dataset.headboardType=none?'':model;
    button.setAttribute('aria-pressed','false');
    const visual=document.createElement('span');
    visual.className='cdb-v2__headboard-type-visual'+(none?' cdb-v2__headboard-type-visual--none':'');
    visual.setAttribute('aria-hidden','true');
    if(none)visual.textContent='—';
    else{
      const image=headboardImage(model);
      if(image)visual.style.backgroundImage='url("'+image+'")';
    }
    const title=document.createElement('strong');
    title.textContent=none?'Uten gavl':model;
    const price=document.createElement('small');
    price.className='cdb-v2__component-price'+(none?' cdb-v2__component-price--none':'');
    if(none){
      const included=document.createElement('span');
      included.textContent='Ingen pristillegg';
      price.append(included);
    }else{
      const minPrice=Math.min(...items.map(x=>x.price));
      const lowest=items.filter(x=>x.price===minPrice);
      const sale=lowest.find(x=>x.compareAtPrice>x.price);
      const current=document.createElement('span');
      current.textContent='fra '+money(minPrice);
      price.append(current);
      if(sale){
        const compare=document.createElement('s');
        compare.textContent=money(sale.compareAtPrice);
        const badge=document.createElement('em');
        badge.textContent='Salg −'+Math.round((1-sale.price/sale.compareAtPrice)*100)+'%';
        price.append(compare,badge);
      }
    }
    if(!none){const image=headboardImage(model);if(image){visual.style.position='relative';const zoom=document.createElement('span');zoom.setAttribute('role','button');zoom.setAttribute('tabindex','0');zoom.setAttribute('aria-label','Forstørr bilde av '+model);zoom.title='Forstørr bilde';zoom.innerHTML='<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>';Object.assign(zoom.style,{position:'absolute',right:'8px',bottom:'8px',width:'32px',height:'32px',display:'flex',alignItems:'center',justifyContent:'center',background:'#fff',color:'#111',borderRadius:'50%',boxShadow:'0 1px 5px rgba(0,0,0,.22)',cursor:'zoom-in',zIndex:'2'});const show=event=>{event.preventDefault();event.stopPropagation();openZoom(image,model,'headboard');};zoom.addEventListener('click',show);zoom.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){show(event);}});visual.append(zoom);}}
    button.append(visual,title,price);
    return button;
  };
  let pendingHeadboardGroup='';
  let pendingHeadboardId='';
  const noneHeadboardCard=makeHeadboardCard('',[],true);
  noneHeadboardCard.addEventListener('click',()=>{headboardInput.value='';renderHeadboard();update();});
  headboardQuick.append(noneHeadboardCard);
  [...headboardGroups.entries()].slice(0,3).forEach(([model,items])=>{
    const button=makeHeadboardCard(model,items);
    button.addEventListener('click',()=>openHeadboardDialog(model));
    headboardQuick.append(button);
  });
  headboardGroups.forEach((items,model)=>{
    const button=makeHeadboardCard(model,items);
    button.addEventListener('click',()=>{
      pendingHeadboardGroup=model;
      pendingHeadboardId=items.length===1?items[0].id:'';
      renderPendingHeadboard();
    });
    headboardModalGrid.append(button);
  });
  const selectedHeadboardGroup=()=>{
    const headboard=config.headboards.find(x=>x.id===headboardInput.value);
    return headboard?headboardModel(headboard.name):'';
  };
  function openHeadboardDialog(group){
    const currentGroup=selectedHeadboardGroup();
    pendingHeadboardGroup=group||currentGroup||headboardGroups.keys().next().value||'';
    pendingHeadboardId=pendingHeadboardGroup===currentGroup?headboardInput.value:'';
    const items=headboardGroups.get(pendingHeadboardGroup)||[];
    if(!pendingHeadboardId&&items.length===1)pendingHeadboardId=items[0].id;
    renderPendingHeadboard();
    headboardDialog.showModal();
  }
  function renderPendingHeadboard(){
    headboardModalGrid.querySelectorAll('[data-headboard-type]').forEach(button=>{
      const active=button.dataset.headboardType===pendingHeadboardGroup;
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-pressed',String(active));
    });
    const items=headboardGroups.get(pendingHeadboardGroup)||[];
    pendingHeadboardName.textContent=pendingHeadboardGroup||'Velg gavl';
    pendingHeadboardPrice.textContent=items.length?'fra '+money(Math.min(...items.map(x=>x.price))):'';
    headboardModalOptions.replaceChildren();
    items.forEach(headboard=>{
      const button=document.createElement('button');
      button.type='button';
      button.className='cdb-v2__headboard-option';
      button.dataset.headboard=headboard.id;
      button.textContent=headboardVariantLabel(headboard,pendingHeadboardGroup)+' · '+money(headboard.price);
      const active=headboard.id===pendingHeadboardId;
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-pressed',String(active));
      button.addEventListener('click',()=>{pendingHeadboardId=headboard.id;renderPendingHeadboard();});
      headboardModalOptions.append(button);
    });
  }
  function renderHeadboard(){
    const headboard=config.headboards.find(x=>x.id===headboardInput.value);
    headboardSelected.textContent=headboard?headboard.name+' · '+money(headboard.price):'Uten gavl';
    const group=selectedHeadboardGroup();
    headboardQuick.querySelectorAll('[data-headboard-type]').forEach(button=>{
      const active=button.dataset.headboardType===group;
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-pressed',String(active));
    });
    noneHeadboardCard.classList.toggle('is-active',!headboard);
    noneHeadboardCard.setAttribute('aria-pressed',String(!headboard));
  }
  headboardMore.addEventListener('click',()=>openHeadboardDialog(''));
  headboardClose.addEventListener('click',()=>headboardDialog.close());
  headboardDialog.addEventListener('click',event=>{if(event.target===headboardDialog)headboardDialog.close();});
  headboardZoom.addEventListener('click',()=>{
    if(!pendingHeadboardGroup)return;
    const image=headboardImage(pendingHeadboardGroup);
    if(image)openZoom(image,pendingHeadboardGroup,'headboard');
  });
  headboardConfirm.addEventListener('click',()=>{
    if(!pendingHeadboardId){
      const first=(headboardGroups.get(pendingHeadboardGroup)||[])[0];
      if(first)pendingHeadboardId=first.id;
    }
    if(pendingHeadboardId){
      headboardInput.value=pendingHeadboardId;
      renderHeadboard();
      update();
      headboardDialog.close();
    }
  });
  headboardInput.value='';
  renderHeadboard();

  const topperInput=form.elements.topper;
  const topperRoot=root.querySelector('[data-topper-options]');
  const topperImages={
  Prestige: 'https://cdn.shopify.com/s/files/1/0911/4668/2732/files/Prestige-overmadrass-Carpe-Diem-Beds.webp?v=1787574183',
  Premium: 'https://cdn.shopify.com/s/files/1/0911/4668/2732/files/Premium-overmadrass-Carpe-Diem-Beds2.webp?v=1760425502',
  Luxury: 'https://cdn.shopify.com/s/files/1/0911/4668/2732/files/Luxury_overmadrass_carpe_diem_beds.webp?v=1749112004'
};
  const topperImage=topper=>Object.entries(topperImages).find(([name])=>topper.name.startsWith(name))?.[1]||'';
  const topperChoices=[{id:'',name:'Uten overmadrass',price:0},...config.topper];
  topperChoices.forEach(topper=>{
    const button=document.createElement('button');
    button.type='button';
    button.className='cdb-v2__topper-card'+(!topper.id?' cdb-v2__topper-card--none':'');
    button.dataset.topper=topper.id;
    button.setAttribute('aria-pressed','false');
    const imageUrl=topper.id?topperImage(topper):'';
    if(imageUrl){
  const imageWrap=document.createElement('span');
  imageWrap.className='cdb-v2__topper-image-wrap';

  const img=document.createElement('img');
  img.src=imageUrl;
  img.alt=topper.name+' overmadrass fra Carpe Diem Beds';
  img.loading='lazy';
  imageWrap.append(img);

  const zoomButton=document.createElement('span');
  zoomButton.className='cdb-v2__topper-zoom';
  zoomButton.setAttribute('role','button');
  zoomButton.setAttribute('tabindex','0');
  zoomButton.setAttribute('aria-label','Forstørr bilde av '+topper.name);
  
zoomButton.innerHTML=`
  <svg xmlns="http://www.w3.org/2000/svg"
       width="16" height="16"
       viewBox="0 0 24 24"
       fill="none"
       stroke="currentColor"
       stroke-width="2"
       stroke-linecap="round"
       stroke-linejoin="round"
       aria-hidden="true">
    <circle cx="11" cy="11" r="8"></circle>
    <path d="m21 21-4.35-4.35"></path>
  </svg>
`;


  const showTopperZoom=(event)=>{
    event.preventDefault();
    event.stopPropagation();
    openZoom(imageUrl,topper.name+' – Carpe Diem Beds overmadrass','topper');
  };

  zoomButton.addEventListener('click',showTopperZoom);
  zoomButton.addEventListener('keydown',(event)=>{
    if(event.key==='Enter'||event.key===' '){
      showTopperZoom(event);
    }
  });

  imageWrap.append(zoomButton);
  button.append(imageWrap);
} else {
      const placeholder=document.createElement('div');
      placeholder.className='cdb-v2__topper-placeholder';
      placeholder.setAttribute('aria-hidden','true');
      placeholder.textContent='—';
      button.append(placeholder);
    }
    const body=document.createElement('div');
    body.className='cdb-v2__topper-body';
    const title=document.createElement('strong');
    title.className='cdb-v2__topper-title';
    title.textContent=topper.name.replace(new RegExp('\\s*'+config.width+'\\s*[x×]\\s*'+config.length,'i'),'').trim();
    const info=document.createElement('span');
    info.className='cdb-v2__topper-info';
    if(!topper.id) info.textContent='Velg hvis du allerede har overmadrass.';
    else if(topper.name.startsWith('Luxury')) info.textContent='Vendbar og med valgfritt tekstil.';
    else if(topper.name.startsWith('Premium')) info.textContent='Ekstra komfort og støtte.';
    else if(topper.name.startsWith('Prestige')) info.textContent='Myk og smidig komfort.';
    else info.textContent='Tilpasset sengens størrelse.';
    body.append(title,info);
    const price=document.createElement('div');
    price.className='cdb-v2__topper-price';
    if(!topper.id){
      const included=document.createElement('strong');
      included.textContent='Inkludert';
      price.append(included);
    }else if(topper.compareAtPrice>topper.price){
      const row=document.createElement('div');
      row.className='cdb-v2__topper-price-row';
      const current=document.createElement('strong');
      current.className='cdb-v2__sale-price';
      current.textContent='+ '+money(topper.price);
      const original=document.createElement('s');
      original.className='cdb-v2__compare-price';
      original.textContent=money(topper.compareAtPrice);
      row.append(current,original);
      const discount=document.createElement('span');
      discount.className='cdb-v2__sale-badge';
      discount.textContent='Salg −'+Math.round((1-topper.price/topper.compareAtPrice)*100)+'%';
      price.append(row,discount);
    }else{
      const current=document.createElement('strong');
      current.textContent='+ '+money(topper.price);
      price.append(current);
    }
    button.append(body,price);
    button.addEventListener('click',()=>{topperInput.value=topper.id;renderTopper();update();});
    topperRoot.append(button);
  });
  function renderTopper(){
    topperRoot.querySelectorAll('[data-topper]').forEach(button=>{
      const active=button.dataset.topper===topperInput.value;
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-pressed',String(active));
    });
  }
  topperInput.value='';
  renderTopper();

  const fabricInput=form.elements.bedFabric;
  const fabricGrid=root.querySelector('[data-fabric-swatches]');
  const fabricSelected=root.querySelector('[data-fabric-selected]');
  const fabricMore=root.querySelector('[data-fabric-more]');
  let fabricsExpanded=false;
  const fabricUrlMap={
  "Cliff Light Grey": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-cliff-light-grey.jpg?v=1790248092",
  "Luxury Black": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-luxury-black.jpg?v=1790248093",
  "Luxury Dark Grey": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-luxury-dark-grey.jpg?v=1790248093",
  "Luxury Light Grey": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-luxury-light-grey.jpg?v=1790248094",
  "Luxury Sand": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-luxury-sand.jpg?v=1790248094",
  "Wool Beige": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-wool-beige.jpg?v=1790248094",
  "Wool Dark Grey": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-wool-dark-grey.jpg?v=1790248093",
  "Wool Light Grey": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-wool-light-grey.jpg?v=1790248094",
  "Wool Black": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-wool-black.jpg?v=1790248094",
  "Designers Guild Zaragoza Eggshell": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-zaragoza-eggshell.jpg?v=1790248094",
  "Designers Guild Zaragoza Pebble": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-zaragoza-pebble.jpg?v=1790248094",
  "Designers Guild Zaragoza Steel": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-zaragoza-steel.jpg?v=1790248094",
  "Designers Guild Rothesay Stone": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-rothesay-stone.jpg?v=1790248093",
  "Designers Guild Rothesay Zinc": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-rothesay-zinc.jpg?v=1790248094",
  "Designers Guild Rothesay Pumice": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-rothesay-pumice.jpg?v=1790248094",
  "Designers Guild Rothesay Graphite": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-rothesay-graphite.jpg?v=1790248094",
  "Designers Guild Glenville Celadon E02": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-glenville-celadon.jpg?v=1790248094",
  "Designers Guild Glenville Granite E01": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-glenville-granite.jpg?v=1790248094",
  "Designers Guild Glenville Oyster E03": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-glenville-oyster.jpg?v=1790248094",
  "Designers Guild Glenville Zinc E00": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-glenville-zinc.jpg?v=1790248094",
  "Designers Guild Azuara Ecru E22": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-azuara-ecru.jpg?v=1790248094",
  "Designers Guild Azuara Natural E23": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-azuara-natural.jpg?v=1790248094",
  "Designers Guild Skye Chalk E37": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-skye-chalk.jpg?v=1790248094",
  "Designers Guild Skye Aqua E39": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-skye-aqua.jpg?v=1790248093",
  "Designers Guild Skye Midnight E40": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-skye-midnight.jpg?v=1790248094",
  "Designers Guild Skye Zinc E38": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-skye-zinc.jpg?v=1790248094",
  "Designers Guild Derwen Japanese Ink E29": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-derwen-japanese-ink.jpg?v=1790248094",
  "Designers Guild Derwen Notting Hill E28": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-derwen-notting-hill.jpg?v=1790248094",
  "Designers Guild Derwen Retro Olive E30": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-derwen-retro-olive.jpg?v=1790248094",
  "Romo Group Asuri Cashew E16": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-asuri-cashew.jpg?v=1790248094",
  "Romo Group Asuri Rose Quartz E19": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-asuri-rose.jpg?v=1790248094",
  "Romo Group Asuri Mulberry E18": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-asuri-mulberry.jpg?v=1790248094",
  "Romo Group Asuri Pigeon E21": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-asuri-pigeon.jpg?v=1790248094",
  "Romo Group Asuri Antler E20": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-asuri-antler.jpg?v=1790248094",
  "Romo Group Loop Oyster E24": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-loop-oyster.jpg?v=1790248094",
  "Romo Group Loop Stone E25": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-loop-stone.jpg?v=1790248094",
  "Romo Group Loop Evergreen E26": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-loop-evergreen.jpg?v=1790248094",
  "Romo Group Loop Marine E27": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-loop-marine.jpg?v=1790248094",
  "Kvadrat Fiord2 262 Light Brown E35": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-fiord2-262.jpg?v=1790248094",
  "Kvadrat Fiord2 171 Dark Grey": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-fiord2-171.jpg?v=1790248094",
  "Kvadrat Fiord2 322 Beige E34": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-fiord2-322.jpg?v=1790248094",
  "Kvadrat Melange NAP 111 Light Grey E32": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-melange-nap-111.jpg?v=1790248094",
  "Kvadrat Melange NAP 211 Beige E31": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-melange-nap-211.jpg?v=1790248094",
  "Kvadrat Melange NAP 191 Dark Grey E33": "https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-melange-nap-191.jpg?v=1790248094"
};
  const fabricUrl=f=>fabricUrlMap[f.name]||f.swatch_url;
  const fabricDialog=root.querySelector('[data-fabric-dialog]');
  const fabricClose=root.querySelector('[data-fabric-close]');
  const classicGrid=root.querySelector('[data-fabric-classic]');
  const exclusiveGrid=root.querySelector('[data-fabric-exclusive]');
  let pendingFabricKey=fabricInput.value||config.fabrics[0]?.key||'';
  const pendingName=root.querySelector('[data-fabric-pending-name]');
  const pendingMeta=root.querySelector('[data-fabric-pending-meta]');
  const fabricConfirm=root.querySelector('[data-fabric-confirm]');
  const fabricZoom=root.querySelector('[data-fabric-zoom]');
  const chooseFabric=f=>{
    fabricInput.value=f.key;
    renderFabric();
    update();
  };
  const renderPendingFabric=()=>{
    const f=config.fabrics.find(x=>x.key===pendingFabricKey);
    if(!f)return;
    pendingName.textContent=f.name;
    pendingMeta.textContent=f.collection==='Exclusive'?'Exclusive · pristillegg':'Classic · inkludert';
    fabricDialog.querySelectorAll('.cdb-v2__fabric-card[data-fabric]').forEach(b=>b.classList.toggle('is-active',b.dataset.fabric===pendingFabricKey));
  };
  const addFabricZoom=(card,f)=>{const image=fabricUrl(f);if(!image)return;card.style.position='relative';const zoom=document.createElement('span');zoom.setAttribute('role','button');zoom.setAttribute('tabindex','0');zoom.setAttribute('aria-label','Forstørr tekstil '+f.name);zoom.title='Forstørr tekstil';zoom.innerHTML='<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>';Object.assign(zoom.style,{position:'absolute',right:'6px',top:'6px',width:'32px',height:'32px',display:'flex',alignItems:'center',justifyContent:'center',background:'#fff',color:'#111',borderRadius:'50%',boxShadow:'0 1px 5px rgba(0,0,0,.22)',cursor:'zoom-in',zIndex:'3'});const show=event=>{event.preventDefault();event.stopPropagation();openZoom(image,f.name,'fabric');};zoom.addEventListener('click',show);zoom.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){show(event);}});card.append(zoom);};
  config.fabrics.forEach((f,i)=>{
    if(i<8){
      const b=document.createElement('button');b.type='button';b.className='cdb-v2__swatch';b.dataset.fabric=f.key;b.title=f.name;b.setAttribute('aria-label',f.name);
      const img=document.createElement('img');img.src=fabricUrl(f);img.alt=f.name;img.loading='lazy';
      b.append(img);
      addFabricZoom(b,f);
      b.addEventListener('click',()=>chooseFabric(f));
      fabricGrid.append(b);
    }
    const card=document.createElement('button');card.type='button';card.className='cdb-v2__fabric-card';card.dataset.fabric=f.key;
    const img=document.createElement('img');img.src=fabricUrl(f);img.alt=f.name;img.loading='lazy';
    const label=document.createElement('span');label.textContent=f.name;
    const meta=document.createElement('em');meta.textContent=f.collection==='Exclusive'?'Exclusive · pristillegg':'Classic · inkludert';
    card.append(img,label,meta);
    addFabricZoom(card,f);
    card.addEventListener('click',()=>{pendingFabricKey=f.key;renderPendingFabric();});
    (f.collection==='Exclusive'?exclusiveGrid:classicGrid).append(card);
  });
  function renderFabric(){
    const f=config.fabrics.find(x=>x.key===fabricInput.value)||config.fabrics[0];
    if(!f)return;
    fabricInput.value=f.key;
    fabricSelected.innerHTML='';
    const name=document.createTextNode(f.name);fabricSelected.append(name);
    const small=document.createElement('small');small.textContent=f.collection==='Exclusive'?'Exclusive · pristillegg':'Classic · inkludert';fabricSelected.append(small);
    root.querySelectorAll('[data-fabric]').forEach(b=>b.classList.toggle('is-active',b.dataset.fabric===f.key));
  }
  fabricMore.addEventListener('click',()=>{pendingFabricKey=fabricInput.value;renderPendingFabric();fabricDialog.showModal();});
  fabricZoom.addEventListener('click',()=>{const f=config.fabrics.find(x=>x.key===pendingFabricKey);if(f)openZoom(fabricUrl(f),f.name,'fabric');});
  fabricConfirm.addEventListener('click',()=>{const f=config.fabrics.find(x=>x.key===pendingFabricKey);if(f)chooseFabric(f);fabricDialog.close();});
  fabricClose.addEventListener('click',()=>fabricDialog.close());
  fabricDialog.addEventListener('click',event=>{if(event.target===fabricDialog)fabricDialog.close();});
  fabricInput.value=config.fabrics[0]?.key||'';renderFabric();

  const legInput=form.elements.leg;
  const legHeightConfirmed=form.elements.legHeightConfirmed;
  const legQuick=root.querySelector('[data-leg-quick]');
  const legMore=root.querySelector('[data-leg-more]');
  const legDialog=root.querySelector('[data-leg-dialog]');
  const legClose=root.querySelector('[data-leg-close]');
  const legModalGrid=root.querySelector('[data-leg-modal-grid]');
  const legModalHeights=root.querySelector('[data-leg-modal-heights]');
  const legConfirm=root.querySelector('[data-leg-confirm]');
  const legZoom=root.querySelector('[data-leg-zoom]');
  const legSelected=root.querySelector('[data-leg-selected]');
  const legLayoutInput=form.elements.legLayout;
  const legLayoutWrap=root.querySelector('[data-leg-layout-wrap]');
  const legLayoutOptions=root.querySelector('[data-leg-layout-options]');
  const legLayoutNote=root.querySelector('[data-leg-layout-note]');
  const pendingLegName=root.querySelector('[data-leg-pending-name]');
  const pendingLegPrice=root.querySelector('[data-leg-pending-price]');
  const legGroups=new Map();
  config.legs.forEach(leg=>{
    const m=leg.name.match(/^(.*?)(?:\s(13|17|23|30) cm)$/);
    const group=m?m[1]:leg.name;
    const height=m?m[2]+' cm':'Velg';
    if(!legGroups.has(group))legGroups.set(group,[]);
    legGroups.get(group).push({...leg,height});
  });
  const legImages={
    oak:'https://cdn.shopify.com/s/files/1/0911/4668/2732/files/5055_CarpeDiemBeds_BedLegs_Cylinder_Oak_13cm_b5ba3ed2-b78d-4d6f-8c5f-a1b2f8c579cb.webp?v=1787574184',
    aluminiumGrey:'https://cdn.shopify.com/s/files/1/0911/4668/2732/files/v5055_CarpeDiemBeds_BedLegs_CylinderAluminium_Grey_13cm_ecab291d-639d-463f-8094-2bf4ac06328e.jpg?v=1790250778',
    aluminiumBlack:'https://cdn.shopify.com/s/files/1/0911/4668/2732/files/v5055_CarpeDiemBeds_BedLegs_CylinderAluminium_Black_13cm_82e7064f-93de-4258-bd3a-d57445432457.jpg?v=1790250778',
    aluminiumWenge:'https://cdn.shopify.com/s/files/1/0911/4668/2732/files/v5055_CarpeDiemBeds_BedLegs_CylinderAluminium_Wenge_13cm_9c374568-96ae-4d0d-ace6-a3583d0f83cf.jpg?v=1790250778',
    aluminiumWhite:'https://cdn.shopify.com/s/files/1/0911/4668/2732/files/v5055_CarpeDiemBeds_BedLegs_CylinderAluminium_White_13cm_64c3e148-2026-49dd-93ef-f1af9e9871d6.jpg?v=1790250778',
    aluminiumOak:'https://cdn.shopify.com/s/files/1/0911/4668/2732/files/5055_CarpeDiemBeds_BedLegs_CylinderAluminium_Oak_13cm_957985d1-7a00-4a32-b153-b1935b42509a.jpg?v=1790250778',
    cylinderWenge:'https://cdn.shopify.com/s/files/1/0911/4668/2732/files/v5055_CarpeDiemBeds_BedLegs_Cylinder_Wenge_13cm_d6e84943-1925-48a3-b465-d818ce1c3663.jpg?v=1790250996',
    classicAluminium:'https://cdn.shopify.com/s/files/1/0911/4668/2732/files/733279100006200.jpg?v=1790250997',
    classicBlack:'https://cdn.shopify.com/s/files/1/0911/4668/2732/files/v5055_Classic_Black_2.jpg?v=1790251218',
    segelAluminium:'https://cdn.shopify.com/s/files/1/0911/4668/2732/files/v5055_Segel_Leg_2_2649a1f1-2e31-43c1-a9b8-5b8c169ca30a.jpg?v=1790251217',
    lodChrome:'https://cdn.shopify.com/s/files/1/0911/4668/2732/files/5055_lod_chrome_2_3c24ee96-11b8_yurr5pno94dhkuli.png?v=1790252015',
    cylinderWalnut:'https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-cylinder-valnott-13cm.webp?v=1790252868',
    lodBlack:'https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-lod-svart.webp?v=1790252893',
    lodBrass:'https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-lod-messing.webp?v=1790252888'
  };
  const legVisual=name=>{
    if(/tre\/metall.*antrasitt|antrasitt/i.test(name))return {image:legImages.aluminiumGrey};
    if(/tre\/metall.*svart/i.test(name))return {image:legImages.aluminiumBlack};
    if(/tre\/metall.*wenge/i.test(name))return {image:legImages.aluminiumWenge};
    if(/tre\/metall.*hvit/i.test(name))return {image:legImages.aluminiumWhite};
    if(/tre\/metall.*oljet/i.test(name))return {image:legImages.aluminiumOak};
    if(/^Cylinder Eik/i.test(name))return {image:legImages.oak};
    if(/^Cylinder Wenge/i.test(name))return {image:legImages.cylinderWenge};
    if(/Valnøtt/i.test(name))return {image:legImages.cylinderWalnut};
    if(/Classic.*Aluminium/i.test(name))return {image:legImages.classicAluminium};
    if(/Classic.*Svart/i.test(name))return {image:legImages.classicBlack};
    if(/Segel/i.test(name))return {image:legImages.segelAluminium};
    if(/Lod.*Svart/i.test(name))return {image:legImages.lodBlack};
    if(/Lod.*Krom/i.test(name))return {image:legImages.lodChrome};
    if(/Lod.*Messing/i.test(name))return {image:legImages.lodBrass};
    return {bg:'#f3f3f1'};
  };
  const shortLegName=name=>name
    .replace(/^Cylinder tre\/metall /i,'Cylinder ')
    .replace(/^Cylinder /i,'Cylinder ')
    .replace(/^Classic /i,'Classic ');
  const applyLegVisual=(visual,name)=>{
    const media=legVisual(name);
    visual.style.background='';
    visual.style.backgroundImage='';
    if(media.bg)visual.style.background=media.bg;
    if(media.image){
      visual.style.background='#f5f5f3';
      visual.style.backgroundImage='url("'+media.image+'")';
      visual.style.backgroundPosition='center';
      visual.style.backgroundSize='contain';
      visual.style.backgroundRepeat='no-repeat';
    }
  };
  const makeLegCard=(name,legs,compact=false)=>{
    const button=document.createElement('button');
    button.type='button';
    button.className='cdb-v2__leg-type';
    button.dataset.legType=name;
    button.setAttribute('aria-pressed','false');
    const visual=document.createElement('span');
    visual.className='cdb-v2__leg-type-visual';
    visual.setAttribute('aria-hidden','true');
    applyLegVisual(visual,name);
    const title=document.createElement('strong');title.textContent=shortLegName(name);
    const minPrice=Math.min(...legs.map(x=>x.price));
    const lowest=legs.filter(x=>x.price===minPrice);
    const sale=lowest.find(x=>x.compareAtPrice>x.price);
    const price=document.createElement('small');
    price.className='cdb-v2__component-price';
    const current=document.createElement('span');
    current.textContent='fra '+money(minPrice);
    price.append(current);
    if(sale){
      const compare=document.createElement('s');
      compare.textContent=money(sale.compareAtPrice);
      const badge=document.createElement('em');
      badge.textContent='Salg −'+Math.round((1-sale.price/sale.compareAtPrice)*100)+'%';
      price.append(compare,badge);
    }
    button.append(visual,title,price);
    return button;
  };
  let pendingLegGroup='';
  let pendingLegId='';
  [...legGroups.entries()].slice(0,4).forEach(([name,legs])=>{
    const button=makeLegCard(name,legs,true);
    button.addEventListener('click',()=>openLegDialog(name));
    legQuick.append(button);
  });
  legGroups.forEach((legs,name)=>{
    const button=makeLegCard(name,legs);
    button.addEventListener('click',()=>{pendingLegGroup=name;pendingLegId='';legHeightConfirmed.value='';renderPendingLeg();});
    legModalGrid.append(button);
  });
  const selectedLegGroup=()=>{
    const leg=config.legs.find(x=>x.id===legInput.value);
    if(!leg)return '';
    const m=leg.name.match(/^(.*?)(?:\s(13|17|23|30) cm)$/);
    return m?m[1]:leg.name;
  };
  function openLegDialog(group){
    const currentGroup=selectedLegGroup();
    pendingLegGroup=group||currentGroup||legGroups.keys().next().value||'';
    pendingLegId=(pendingLegGroup===currentGroup&&legHeightConfirmed.value==='yes')?legInput.value:'';
    if(!pendingLegId)legHeightConfirmed.value='';
    renderPendingLeg();
    legDialog.showModal();
  }
  function renderPendingLeg(){
    legModalGrid.querySelectorAll('[data-leg-type]').forEach(button=>{
      const active=button.dataset.legType===pendingLegGroup;
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-pressed',String(active));
    });
    const legs=legGroups.get(pendingLegGroup)||[];
    const sortedLegs=[...legs].sort((a,b)=>parseInt(a.height)-parseInt(b.height));
    if(sortedLegs.length===1&&!pendingLegId){
      pendingLegId=sortedLegs[0].id;
      legHeightConfirmed.value='yes';
    }
    pendingLegName.textContent=pendingLegGroup?shortLegName(pendingLegGroup):'Velg bentype';
    pendingLegPrice.textContent=legs.length?'fra '+money(Math.min(...legs.map(x=>x.price))):'';
    legConfirm.disabled=!pendingLegId||legHeightConfirmed.value!=='yes';
    legModalHeights.replaceChildren();
    sortedLegs.forEach(leg=>{
      const button=document.createElement('button');
      button.type='button';
      button.className='cdb-v2__leg';
      button.dataset.leg=leg.id;
      button.textContent=leg.height+' · '+money(leg.price);
      const active=leg.id===pendingLegId;
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-pressed',String(active));
      button.addEventListener('click',()=>{pendingLegId=leg.id;legHeightConfirmed.value='yes';renderPendingLeg();});
      legModalHeights.append(button);
    });
  }
  const enabledLegLayouts=(config.leg_layouts||[]).filter(x=>x.enabled);
  if(enabledLegLayouts.length&&legLayoutWrap&&legLayoutOptions&&legLayoutInput){
    legLayoutWrap.hidden=false;
    legLayoutInput.value=enabledLegLayouts[0].key;
    enabledLegLayouts.forEach(layout=>{
      const button=document.createElement('button');
      button.type='button';
      button.className='cdb-v2__leg-layout-btn';
      button.dataset.legLayout=layout.key;
      const title=document.createElement('strong');
      title.textContent=layout.label;
      const desc=document.createElement('span');
      desc.textContent=layout.description||'';
      button.append(title,desc);
      button.addEventListener('click',()=>{
        if(button.disabled)return;
        legLayoutInput.value=layout.key;
        renderLegLayout();
        update();
      });
      legLayoutOptions.append(button);
    });
  }
  function renderLegLayout(){
    if(!legLayoutInput||!legLayoutOptions)return;
    const selectedLeg=config.legs.find(x=>x.id===legInput.value);
    const match=selectedLeg?.name.match(/\b(13|17|23|30) cm$/i);
    const height=match?match[1]:'';
    const supportAllowed=['13','17','23'].includes(height);
    if(legLayoutInput.value==='4-plus-support'&&!supportAllowed){
      legLayoutInput.value='8-visible';
    }
    legLayoutOptions.querySelectorAll('[data-leg-layout]').forEach(button=>{
      const isSupport=button.dataset.legLayout==='4-plus-support';
      button.disabled=isSupport&&!supportAllowed;
      const active=button.dataset.legLayout===legLayoutInput.value;
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-pressed',String(active));
    });
    if(legLayoutNote){
      legLayoutNote.textContent=height==='30'
        ? '30 cm ben krever 8 synlige ben. Støttebenalternativet kan brukes med 13, 17 eller 23 cm.'
        : 'Støtteben monteres skjult i midten under sengen og leveres som én pakke à 2 stk. (+300 kr).';
    }
  }
  function renderLeg(){
    const leg=config.legs.find(x=>x.id===legInput.value);
    legSelected.textContent=leg?leg.name+' · '+money(leg.price):'Velg ben';
    renderLegLayout();
    const group=selectedLegGroup();
    legQuick.querySelectorAll('[data-leg-type]').forEach(button=>{
      const active=button.dataset.legType===group;
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-pressed',String(active));
    });
  }
  legMore.addEventListener('click',()=>openLegDialog(''));
  legClose.addEventListener('click',()=>legDialog.close());
  legDialog.addEventListener('click',event=>{if(event.target===legDialog)legDialog.close();});
  legZoom.addEventListener('click',()=>{
    if(!pendingLegGroup)return;
    const media=legVisual(pendingLegGroup);
    if(media.image)openZoom(media.image,shortLegName(pendingLegGroup),'leg');
  });
  legConfirm.addEventListener('click',()=>{
    if(!pendingLegGroup){
      pendingLegPrice.textContent='Velg bentype først.';
      return;
    }
    if(!pendingLegId||legHeightConfirmed.value!=='yes'){
      pendingLegPrice.textContent='Velg høyde før du velger ben.';
      legConfirm.disabled=true;
      legModalHeights.querySelector('button')?.focus();
      return;
    }
    legInput.value=pendingLegId;
    renderLeg();
    update();
    legDialog.close();
  });
  const defaultLeg=config.legs.find(x=>/^Cylinder tre\/metall Antrasittgrå 13 cm$/i.test(x.name))||config.legs[0];
  legInput.value=defaultLeg?.id||'';
  legHeightConfirmed.value=defaultLeg?'yes':'';
  renderLeg();
  form.elements.left.value='Medium';
  if(singleBed){
    form.elements.right.value='';
    root.querySelector('[data-firmness-side="right"]')?.setAttribute('hidden','');
  }else{
    form.elements.right.value='Fast';
  }
  renderFirmness('left');
  if(!singleBed)renderFirmness('right');
  let current;
  function update() {
    const choice=Object.fromEntries(new FormData(form));
    const selectedFabric=config.fabrics.find(x=>x.key===choice.bedFabric);
    if(form.elements.topperFabric)form.elements.topperFabric.value=choice.bedFabric||'';
    if(form.elements.headboardFabric)form.elements.headboardFabric.value=choice.bedFabric||'';
    const luxury=config.topper.find(x=>x.id===choice.topper)?.name.startsWith('Luxury');
    const topperFabricInfo=root.querySelector('[data-topper-fabric]');
    topperFabricInfo.hidden=!luxury;
    const topperFabricName=root.querySelector('[data-topper-fabric-name]');
    if(topperFabricName)topperFabricName.textContent=selectedFabric?.name||'';
    const selectedHeadboard=config.headboards.find(x=>x.id===choice.headboard);
    const headFabricInfo=root.querySelector('[data-head-fabric]');
    headFabricInfo.hidden=!selectedHeadboard||!headboardNeedsFabric(selectedHeadboard.name);
    const headFabricName=root.querySelector('[data-head-fabric-name]');
    if(headFabricName)headFabricName.textContent=selectedFabric?.name||'';
    try {
      current=cdbBuild(config,choice,'pilot-preview');
      const rows=root.querySelector('tbody'); rows.replaceChildren();
      for(const line of current.lines){const tr=document.createElement('tr');const td=document.createElement('td');td.textContent=(line.quantity>1?line.quantity+' × ':'')+line.name;const price=document.createElement('td');price.textContent=money(line.unitPrice*line.quantity);tr.append(td,price);rows.append(tr);}
      root.querySelector('[data-total]').textContent=money(current.total);
      const fullTotal=current.lines.reduce((sum,line)=>sum+Math.max(line.unitPrice,line.compareAtPrice||0)*line.quantity,0);
      const discounted=fullTotal>current.total;
      const compareEl=root.querySelector('[data-cdb-pilot-compare-total]');
      const savingEl=root.querySelector('[data-cdb-pilot-saving]');
      const badgeEl=root.querySelector('[data-cdb-pilot-discount-badge]');
      if(compareEl){compareEl.hidden=!discounted;compareEl.textContent=discounted?money(fullTotal):'';}
      if(savingEl){savingEl.hidden=!discounted;savingEl.textContent=discounted?'Du sparer '+money(fullTotal-current.total):'';}
      if(badgeEl){badgeEl.hidden=!discounted;badgeEl.textContent=discounted?'−'+Math.round(100*(fullTotal-current.total)/fullTotal)+' % rabatt':'';}
      root.querySelector('[data-cart]').disabled=false;
      root.querySelector('[data-status]').textContent='Valgene dine er klare.';
      updateCylindoHero(choice);
    } catch(error){current=null;root.querySelector('[data-cart]').disabled=true;root.querySelector('[data-status]').textContent=error.message;}
  }
  form.addEventListener('change',update);
  form.addEventListener('submit',event=>event.preventDefault());
  update();
  let submitting=false;
  root.querySelector('[data-cart]').addEventListener('click',async()=>{
    if(!current||submitting)return;
    submitting=true;
    const button=root.querySelector('[data-cart]');
    const status=root.querySelector('[data-status]');
    button.disabled=true;
    const group='cdb-'+crypto.randomUUID();
    const choice=Object.fromEntries(new FormData(form));
    const intended=cdbBuild(config,choice,group);
    status.textContent='Kontrollerer pris og tilgjengelighet…';
    let attempted=false;
    try{
      const variants=await Promise.all(intended.lines.map(async line=>{
        const response=await fetch(route('variants/'+line.id+'.js'),{cache:'no-store',headers:{Accept:'application/json'}});
        if(!response.ok)throw new Error('Et av valgene er ikke tilgjengelig. Velg på nytt.');
        const variant=await response.json();
        if(!variant.available)throw new Error(line.name+' er ikke tilgjengelig akkurat nå.');
        return variant;
      }));
      let changed=false;
      for(const variant of variants){
        const item=allItems.find(x=>String(x.id)===String(variant.id))||(config.support_legs||[]).find(x=>String(x.id)===String(variant.id));
        if(!item)throw new Error('Kunne ikke koble et av valgene til konfiguratoren. Last siden på nytt og prøv igjen.');
        if(item.price!==variant.price){item.price=variant.price;changed=true;}
      }
      if(changed){update();throw new Error('Prisen er oppdatert. Kontroller den nye totalen før du legger til.');}
      attempted=true;
      const response=await fetch(route('cart/add.js'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(intended.cart)});
      if(!response.ok)throw new Error('Hele konfigurasjonen kunne ikke legges til. Prøv igjen.');
      const cartResponse=await fetch(route('cart.js'),{cache:'no-store'});
      if(!cartResponse.ok)throw new Error('Kunne ikke kontrollere handlekurven.');
      const cart=await cartResponse.json();
      const added=cart.items.filter(x=>x.properties?._cdb_configuration===group);
      const expected=intended.lines.map(x=>x.properties._cdb_role+':'+x.id+':'+x.quantity).sort().join('|');
      const actual=added.map(x=>x.properties._cdb_role+':'+x.variant_id+':'+x.quantity).sort().join('|');
      const total=added.reduce((sum,x)=>sum+x.original_line_price,0);
      if(expected!==actual||total!==intended.total)throw new Error('Pris eller innhold endret seg. Konfigurasjonen ble ikke beholdt; prøv igjen.');
      status.textContent='Hele konfigurasjonen er kontrollert og lagt i handlekurven.';
      window.location.assign(route('cart')+'');
    }catch(error){
      if(attempted){
        try{
          const response=await fetch(route('cart.js'),{cache:'no-store'});
          if(!response.ok)throw new Error();
          const cart=await response.json();
          const updates=Object.fromEntries(cart.items.filter(x=>x.properties?._cdb_configuration===group).map(x=>[x.key,0]));
          if(Object.keys(updates).length){
            const removed=await fetch(route('cart/update.js'),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})});
            if(!removed.ok)throw new Error();
            const after=await removed.json();
            if(after.items.some(x=>x.properties?._cdb_configuration===group))throw new Error();
          }
        }catch{
          status.textContent='Forbindelsen ble brutt. Åpne handlekurven og kontroller konfigurasjonen før du prøver igjen.';
          const link=document.createElement('a');link.href=route('cart')+'';link.textContent=' Åpne handlekurven';status.append(link);
          return;
        }
      }
      status.textContent=error.message;
      button.disabled=false;submitting=false;
    }
  });

  update();
})();



